import React from "react";
import { getInstrumentDomainTable } from "src/Requests/goldArbitrage";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import {
  InstrumentDomainSearchParams,
  IInstrumentDomainTableReport,
} from "src/Interfaces/goldArbitrage";

const InstrumentDomain = () => {
  return (
    <div className="min-h-32 min-w-[300px] w-full max-w-full overflow-x-auto">
      <TableTemplate<InstrumentDomainSearchParams, IInstrumentDomainTableReport>
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            tableBoxClassName="max-h-[700px]"
          />
        )}
        getDataTable={getInstrumentDomainTable}
        searchParameters={{} as InstrumentDomainSearchParams}
      />
    </div>
  );
};

export default InstrumentDomain;
